// import React, { useState, useEffect } from 'react'
// import Homescreen from './Screens/homescreen'
// import InventoryTracker from './Components/InventoryTracker'
// import { AppConstant } from './AppConstant'
// import Products from './Screens/Products'
// import Aboutus from './Screens/Aboutus'
// import Contactus from './Screens/Contactus'
// import MHeader from './Components/MainscreenHeader'

// function App() {

//   const [activeSection, setActiveSection] = useState('');

//   useEffect(() => {
//     const handleScroll = () => {
//       const sections = ['home', 'product', 'about', 'contact'];
//       for (let id of sections) {
//         const el = document.getElementById(id);
//         if (el) {
//           const rect = el.getBoundingClientRect();
//           if (rect.top <= 100 && rect.bottom >= 100) {
//             setActiveSection(id);
//             break;
//           }
//         }
//       }
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const scrollToSection = (id) => {
//     const section = document.getElementById(id);
//     if (section) {
//       section.scrollIntoView({ behavior: "smooth" });
//       setActiveSection(id); // 👈 force active state on click
//     }
//   };

//   return (
//     <div>
//       <MHeader onNavClick={scrollToSection} activeSection={activeSection} />

//       <div id="home" style={{ scrollMarginTop: '100px' }}>
//         <Homescreen />
//       </div>

//       <div id="product" style={{ scrollMarginTop: '100px' }}>
//         <Products />
//       </div>

//       <div id="about" style={{ scrollMarginTop: '100px', marginTop: '5%' }}>
//         <Aboutus />
//       </div>

//       <div id="contact" style={{ scrollMarginTop: '100px', }}>
//         <Contactus />
//       </div>
//       <a
//         href="/brochure.pdf"
//         download
//         style={{
//           position: "sticky",
//           bottom: 20,
//           right: 20,
//           backgroundColor: AppConstant.Appcolororange,
//           color: "#fff",
//           padding: "12px 20px",
//           borderRadius: "8px",
//           textDecoration: "none",
//           fontWeight: "bold",
//           fontSize: "16px",
//           boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
//           zIndex: 9999,
//           transition: 'all 0.3s ease',
//           margin: '2%'

//         }}
//       >
//         📄 Download Brochure
//       </a>

//     </div>
//   )
// }

// export default App


import React, { useState, useEffect } from "react";
import Homescreen from "./Screens/homescreen";
import Products from "./Screens/Products";
import Aboutus from "./Screens/Aboutus";
import Contactus from "./Screens/Contactus";
import MHeader from "./Components/MainscreenHeader";
import { AppConstant } from "./AppConstant";

function App() {
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    // Remove browser default spacing
    document.body.style.margin = "0";
    document.body.style.padding = "0";
    document.body.style.background = "#ffffff";

    const handleScroll = () => {
      const sections = ["home", "product", "about", "contact"];

      for (let id of sections) {
        const el = document.getElementById(id);

        if (el) {
          const rect = el.getBoundingClientRect();

          if (rect.top <= 120 && rect.bottom >= 120) {
            setActiveSection(id);
            break;
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Detect correct section when page first loads
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);

      document.body.style.margin = "";
      document.body.style.padding = "";
    };
  }, []);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);

    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      setActiveSection(id);
    }
  };

  return (
    <div
      style={{
        width: "100%",
        minHeight: "100vh",
        margin: 0,
        padding: 0,
        background: "#ffffff",
        overflowX: "hidden",
      }}
    >
      {/* HEADER */}
      <MHeader
        onNavClick={scrollToSection}
        activeSection={activeSection}
      />

      {/* HOME */}
      <section
        id="home"
        style={{
          width: "100%",
          margin: 0,
          padding: 0,
          scrollMarginTop: "100px",
        }}
      >
        <Homescreen />
      </section>

      {/* PRODUCTS */}
      <section
        id="product"
        style={{
          width: "100%",
          margin: 0,
          padding: 0,
          scrollMarginTop: "100px",
        }}
      >
        <Products />
      </section>

      {/* ABOUT */}
      <section
        id="about"
        style={{
          width: "100%",
          margin: 0,
          padding: 0,
          scrollMarginTop: "100px",
        }}
      >
        <Aboutus />
      </section>

      {/* CONTACT */}
      <section
        id="contact"
        style={{
          width: "100%",
          margin: 0,
          padding: 0,
          scrollMarginTop: "100px",
        }}
      >
        <Contactus />
      </section>

      {/* =====================================================
          FLOATING BROCHURE BUTTON
      ====================================================== */}

      <a
        href="/brochure.pdf"
        download
        style={{
          position: "fixed",
          right: "22px",
          bottom: "22px",

          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "9px",

          background: AppConstant.Appcolororange || "#ff6500",
          color: "#ffffff",

          padding: "13px 20px",
          borderRadius: "10px",

          textDecoration: "none",
          fontWeight: "800",
          fontSize: "14px",

          boxShadow: "0 10px 30px rgba(0,0,0,0.22)",

          zIndex: 99999,

          transition:
            "transform 0.25s ease, box-shadow 0.25s ease",

          whiteSpace: "nowrap",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-4px)";
          e.currentTarget.style.boxShadow =
            "0 15px 35px rgba(0,0,0,0.28)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow =
            "0 10px 30px rgba(0,0,0,0.22)";
        }}
      >
        <span style={{ fontSize: "16px" }}>📄</span>
        Download Brochure
      </a>
    </div>
  );
}

export default App;